// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonFitToExtend_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0H4L2.35359 1.64641 4.93928 4.2321 4.23218 4.93921 1.64648 2.35352 0 4V0ZM4.23236 7.06061 1.64648 9.64648 0 8V12L4 12 2.35359 10.3536 4.93947 7.76771 4.23236 7.06061ZM7.06061 7.76764 9.64648 10.3535 8 12H12V8L10.3536 9.64641 7.76771 7.06053 7.06061 7.76764ZM7.7679 4.93928 10.3536 2.35359 12 4V0H8L9.64648 1.64648 7.06079 4.23218 7.7679 4.93928Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 0 3.70703 2.29297 7.29297 5.87891 5.87876 7.29312 2.29282 3.70718 0 6V0H6ZM13.7067 3.70669 10.1208 7.2926 8.70658 5.87838 12.2925 2.29248 10 0H16V6L13.7067 3.70669ZM7.29312 10.1212 5.87891 8.70703 2.29297 12.293 0 10V16H6L3.70718 13.7072 7.29312 10.1212ZM8.70643 10.1208 12.2928 13.7072 10 16 16 16V10L13.707 12.293 10.1206 8.70658 8.70643 10.1208Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.41424 2.58576 8 0H0V8L2.58582 5.41418 7.48853 10.3169 10.317 7.48847 5.41424 2.58576ZM16.0591 10.2537 13.2307 7.42529 18.328 2.328 16 0H24V8L21.1564 5.15643 16.0591 10.2537ZM13.5512 15.865 16.3796 13.0366 21.6715 18.3285 24 16V24H16L18.8431 21.1569 13.5512 15.865ZM7.68354 13.489 10.512 16.3174 5.41467 21.4147 8 24 0 24V16L2.58625 18.5862 7.68354 13.489Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonFitToExtend is a generated icon component.
 */
let IconCommonFitToExtend = IconCommonFitToExtend_1 = class IconCommonFitToExtend extends IconBaseElement {
    render() {
        return html `${IconCommonFitToExtend_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonFitToExtend.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonFitToExtend = IconCommonFitToExtend_1 = __decorate([
    customElement('zui-icon-common-fit-to-extend')
], IconCommonFitToExtend);
export { IconCommonFitToExtend };
